import { render, staticRenderFns } from "./dialog-table.vue?vue&type=template&id=3b1d2bd2&scoped=true&"
import script from "./dialog-table.vue?vue&type=script&lang=js&"
export * from "./dialog-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1d2bd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b1d2bd2')) {
      api.createRecord('3b1d2bd2', component.options)
    } else {
      api.reload('3b1d2bd2', component.options)
    }
    module.hot.accept("./dialog-table.vue?vue&type=template&id=3b1d2bd2&scoped=true&", function () {
      api.rerender('3b1d2bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Aftersales/dialog-table.vue"
export default component.exports